import http from '@mgtv/http'
import store from '@/views/v2/store'
import Utils from '@/utils/utils'

export function getCommParams() {
  const userInfo = store.state.userInfo || window.USERINFO
  const devicesInfo = store.state.devicesInfo || window.DEVICEINFO
  return {
    did: devicesInfo.did || Utils.getCookie('mg_uuid') || '',
    deviceId: devicesInfo.did || Utils.getCookie('mg_uuid') || '',
    device: devicesInfo.device || '',
    appVersion: devicesInfo.appVersion || '',
    osType: devicesInfo.osType || '',
    platform: Utils.getUaName(),
    uuid:
      userInfo.uuid || Utils.getCookie('uuid') || localStorage.getItem('uuid'),
    ticket:
      userInfo.ticket ||
      Utils.getCookie('HDCN') ||
      localStorage.getItem('ticket'),
    abroad: '0',
    aid: 635,
  }
}

const HOST = 'https://digital.bz.mgtv.com'
// create an axios instance
const service = http.create({
  baseURL: HOST,
  timeout: 30000,
})

// request interceptor
service.interceptors.request.use(
  (config) => ({
    ...getCommParams(),
    ...config,
  }),
  (error) => Promise.reject(error)
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    return res
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default service
